
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.77 48.75c-1.264 0-2.332-.438-3.207-1.313S6.25 45.493 6.25 44.231V15.769c0-1.263.438-2.332 1.313-3.207.875-.874 1.943-1.312 3.206-1.312h38.462c1.262 0 2.331.438 3.206 1.313.875.874 1.313 1.943 1.313 3.206v28.462c0 1.262-.438 2.331-1.313 3.206s-1.944 1.313-3.206 1.313H10.769zm0-3.75h38.46c.193 0 .37-.08.53-.24.16-.16.24-.337.24-.53V20H10v24.23c0 .193.08.37.24.53.16.16.337.24.53.24zm16.605-9.962l9.192-9.192c.372-.372.82-.562 1.344-.57.524-.008.98.182 1.368.57.388.388.581.84.581 1.356 0 .516-.193.968-.581 1.356L28.957 38.88c-.452.452-.98.678-1.582.678-.603 0-1.13-.226-1.582-.678l-5.072-5.072a1.874 1.874 0 01-.57-1.344c-.008-.524.182-.98.57-1.368.388-.388.84-.582 1.356-.582.516 0 .968.194 1.356.582l3.942 3.942zM10.769 45H10V15h.77c-.192 0-.368.08-.529.24-.16.16-.24.337-.24.53v28.46c0 .193.08.37.24.53.16.16.337.24.53.24z","fill":"#fff"}})])
          )
        }
      }
    